
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";

interface SendCodeButtonProps {
  onClick: () => void;
  isLoading: boolean;
}

export function SendCodeButton({ onClick, isLoading }: SendCodeButtonProps) {
  return (
    <Button onClick={onClick} disabled={isLoading} className="w-full">
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Sending code...
        </>
      ) : (
        <>
          <Send className="mr-2 h-4 w-4" />
          Send verification code
        </>
      )}
    </Button>
  );
}
